import Helper from "./Helper";
import Swiper from "swiper/bundle";

class SliderHandler {
  constructor(config = {}) {
    const {

      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint,
    } = config;

    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";
    this.sliderBreakpoint = sliderBreakpoint || 768;
    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.currentlyDesktop = "";
    this.swiperInstances = [];

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyDesktop = false;
      this.initSwipersMobile();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      // console.log(this.currentlyDesktop);

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersDesktop();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      this.previousScreenWidth = vw;
    });
  }

  initSwipersMobile() {
    this.slidersArray.forEach((slider, index) => {

      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};

        swiperConfig = {
          speed: 600,
          parallax: true,
          slidesPerView: 1,
          centeredSlides: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
          }
        };

      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  destroySwipers() {
    // console.log(this.swiperInstances);
    // console.log("destroy");
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }
}

export default SliderHandler;
